import type { Timestamp, Url } from '@shady-pines/types';
import { type Uuid } from '@shady-pines/types';
import type { Model } from './model';

export const PopupVariant = ['announcement', 'popup'] as const;
export type PopupVariant = (typeof PopupVariant)[number];

export type Popup = Model<{
  id: Uuid<Popup>;
  title: string;
  description: string;
  expires_at: Timestamp;
  enabled: boolean;
  active_at: Timestamp;
  variant: PopupVariant;
  external_url: Url | null;
  video_url: Url | null;
  dismissable: boolean;
  target_up_to_version: null | `${number}.${number}.${number}`;
  target_after_version: null | `${number}.${number}.${number}`;
}>;
